
import React from 'react';
import {cls, Column, Grid, Row, Button} from '../../../packages/components';
import './styles/cardTalentSearch.scss';
import WrapperContentPlay from './WrapperContentPlay';
import UtilsSearch from '../UtilsSearch';
import { MODAL_TALENT_CONTENTS, showModal } from '../../../actions/modal';
import store from '../../../store';
import Asset from '../../../requests/apa/Asset';


const createMarkup =(markup) =>{
    return { __html: markup };
}

const getTextRoles = (roles = []) =>{
    const rolesText = roles.map(({NOMBRE}) => {return NOMBRE}).join(', ');
    return rolesText;
}

const getLeftElement = (contentItem) => {
    if(contentItem && (contentItem.image === null || contentItem.image === '')){
        contentItem.image = Asset.get('content_data_talent_placeholder', '/images/content_data_talent_placeholder.png');
    }
    return (
        <div className={cls(`aaf-main-search-card-talent-main`)}>
            <div
                className={cls('aaf-main-search-card-talent-main-container')}
                id={`modal_episode_number_${contentItem.idx_temp || null}`}
                data-id={contentItem.idx_temp || null}>
                <div className="aaf-main-search-card-talent-main-image">
                    <div
                        className={cls('aaf-main-search-card-talent-main-image-div')}
                        style={{
                            backgroundImage: 'url(' + contentItem.image + ')',
                            backgroundPosition: `center top`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                        }}>
                    </div>
                </div>
            </div>
        </div>
    );
}

const getRightElement = (contentItem,  changeRoute = null, user = null, getTextButtons = null) => {
    const fullname = contentItem && contentItem.fullname ? contentItem.fullname : ' ';
    const roles = contentItem && contentItem.roles.length > 0 && getTextRoles(contentItem.roles)

    return (
        <Grid className={cls('aaf-main-search-card-talent-main-right')}>
            <Row className={cls('aaf-main-search-card-talent-main-right-row')}>
                <Column lg={12} className={cls('aaf-main-search-card-talent-main-right-column','aaf-main-search-card-talent-main-right-column-title')}>
                    {UtilsSearch.cutString(fullname, 19)}
                </Column>
                <Column lg={12} className={cls('aaf-main-search-card-talent-main-right-column','aaf-main-search-card-talent-main-right-column-roles')}>
                    {UtilsSearch.cutString(roles, 33)}
                </Column>
                {/* Se comenta temporalmente*/}
                {/* <Column lg={12} className={cls('aaf-main-search-card-talent-main-right-column', 'aaf-main-search-card-talent-main-right-column-year')}>
                </Column> */}
                {/* <Column lg={12} className={cls('aaf-main-search-card-talent-main-right-column', 'aaf-main-search-card-talent-main-right-column_last')}>
                    <Button id={`${SearchConstants.FOCUSABLE_BUTTON}_${contentItem.idx_temp}`} className={cls(SearchConstants.FOCUSABLE, 'aaf-main-search-card-talent-main-right-button-more-info')} onClick={()=>{moreInfo(contentItem, changeRoute, user)}} dataOptions={{'data-id': contentItem.idx_temp, 'data-from-focusable': SearchConstants.FOCUSABLE_BUTTON}}>
                        {(typeof getTextButtons === 'function') && getTextButtons(SearchConstants.BUTTON_MORE_INFO)}
                    </Button>
                </Column> */}
            </Row>
        </Grid>
    );
}


const onClick = (element, changeRoute, user) =>{
    handleTalentClick(element,changeRoute, user);
}

const moreInfo = (element,  changeRoute, user) =>{
    handleTalentClick(element,changeRoute, user);
}



const handleTalentClick = (talent, changeRoute, user = null) =>{
    const handleCardClick = (groupID) =>{
        (typeof changeRoute === 'function') && changeRoute(groupID);
    }

    const {provider_id} = talent;
    const modal = {
        modalType: MODAL_TALENT_CONTENTS,
        modalProps: {
            talent,
            providerIdFromVCard: provider_id,
            user,
            handleCardClick
        }
    };
    store.dispatch(showModal(modal));
}



const CardTalentSearch = ({onFocus = null, item = {}, changeRoute = null, user= null, getTextButtons = null}) => {
    return (
        <WrapperContentPlay
            children_left = {
                getLeftElement(item)
            }
            children_right={
                getRightElement(item,  changeRoute, user, getTextButtons)
            }
            onClick={() =>{
                onClick(item, changeRoute, user)
            }}
            item ={item}
            onFocus = {onFocus}
        />
    );
};

export default CardTalentSearch;



// WEBPACK FOOTER //
// ./src/containers/Search/components/CardTalentSearch.jsx